if (!customElements.get('quick-add-modal')) {
    customElements.define(
        'quick-add-modal',
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide(preventFocus = false) {
                const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cartNotification) cartNotification.setActiveElement(this.openedBy);
                this.modalContent.innerHTML = '';

                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                opener.querySelector('.loading__spinner').classList.remove('hidden');

                fetch(opener.getAttribute('data-product-url'))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                       // this.productElement = responseHTML.querySelector('section[id^="MainProductCustom-"]');
                       this.productElement = responseHTML.querySelector('section[id^="MainProduct"]');
                        // this.productElement.classList.forEach((classApplied) => {
                        //   if (classApplied.startsWith('color-') || classApplied === 'gradient')
                        //     this.modalContent.classList.add(classApplied);
                        // });
                        this.preventDuplicatedIDs();
                        this.removeDOMElements();
                        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        this.removeGalleryListSemantic();
                        this.updateImageSizes();
                        this.preventVariantURLSwitching();
                        super.show(opener);

                        $('quick-add-modal .products-variants-images .the-grid').slick({
                            infinite: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                            nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                            asNavFor: 'quick-add-modal .products-variants-images-thumb .the-grid',
                            dots: false
                        });

                        $('quick-add-modal .products-variants-images-thumb .the-grid').slick({
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            vertical: true,
                            arrows: true,
                            prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                            nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                            asNavFor: 'quick-add-modal .products-variants-images .the-grid',
                            focusOnSelect: true,
                            infinite: false,
                        });

                        // function loadScript(url, callback) {
                        //     var script = document.createElement("script");
                        //     script.type = "text/javascript";
                        //     script.src = url;

                        //     // Execute the callback function after the script is loaded
                        //     script.onload = callback;

                        //     // Append the script to the document's <head> section
                        //     document.head.appendChild(script);
                        // }
                        // loadScript("https://assets.smartwishlist.webmarked.net/static/v6/smartwishlist.js?shop=f0a053-2.myshopify.com", function() {
                        // });

                    })
                    .finally(() => {
                        $("quick-add-modal variant-radios input").on("change", function () {
                            let newUrl = window.location.href;
                            setTimeout(function () {
                                window.history.pushState({ path: newUrl }, '', newUrl);
                            }, 300);
                        });

                        $("quick-add-modal .opton-finish input").on("change", function () {
                            if ($("quick-add-modal .the-grid").hasClass("slick-slider")) {
                                jQuery('quick-add-modal .products-variants-images .the-grid').slick("unslick");
                                $('quick-add-modal .products-variants-images-thumb .the-grid').slick("unslick");
                            }
                            $(`quick-add-modal .variants-images[data-varaint-title="${$(this).val()}"]`).removeClass("hidden").siblings().addClass("hidden");
                            jQuery('quick-add-modal .products-variants-images .the-grid').slick({
                                infinite: false,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                                nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                                arrows: true,
                                asNavFor: '.products-variants-images-thumb .the-grid',
                                dots: false
                            });

                            $('quick-add-modal .products-variants-images-thumb .the-grid').slick({
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                vertical: true,
                                arrows: true,
                                prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                                nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                                asNavFor: '.products-variants-images .the-grid',
                                focusOnSelect: true,
                                infinite: false
                            });
                        })
                        $("quick-add-modal .opton-gemstone input").on("change", function () {
                            if ($("quick-add-modal .the-grid").hasClass("slick-slider")) {
                                jQuery('quick-add-modal .products-variants-images .the-grid').slick("unslick");
                                $('quick-add-modal .products-variants-images-thumb .the-grid').slick("unslick");
                            }
                            $(`quick-add-modal .variants-images[data-varaint-title="${$(this).val()}"]`).removeClass("hidden").siblings().addClass("hidden");
                            jQuery('quick-add-modal .products-variants-images .the-grid').slick({
                                infinite: false,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                                nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                                arrows: true,
                                asNavFor: '.products-variants-images-thumb .the-grid',
                                dots: false
                            });

                            $('quick-add-modal .products-variants-images-thumb .the-grid').slick({
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                vertical: true,
                                arrows: true,
                                prevArrow: "<button class='a-left control-c prev slick-prev'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/prev.svg?v=1707290984'></button>",
                                nextArrow: "<button class='a-right control-c next slick-next'><img src='https://cdn.shopify.com/s/files/1/0807/1227/0145/files/next.svg?v=1707290984'></button>",
                                asNavFor: '.products-variants-images .the-grid',
                                focusOnSelect: true,
                                infinite: false
                            });
                        })
                        $("quick-add-modal .product-form__input input").on("change", function () {
                            $(this).parents(".product-form__input").find(".form__label span.add_valspan").text($(this).val());
                        })
                        $("#show-popup-btn").on("click", function () {
                            $('.size-guide-popup-main .modal').fadeIn();
                        })
                        $(".size-guide-popup-main .close-btn").on("click", function () {
                            $('.size-guide-popup-main .modal').fadeOut();
                        })
                        $('#show-popup-btnring').click(function () {
                            $('.ring-size-popup-main .modal').fadeIn();
                        })
                        $('.ring-size-popup-main .close-btn').click(function () {
                            $('.ring-size-popup-main .modal').fadeOut();
                        })
                        opener.removeAttribute('aria-disabled');
                        opener.classList.remove('loading');
                        opener.querySelector('.loading__spinner').classList.add('hidden');
                    });
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll('script').forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement('script');
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });
            }

            preventVariantURLSwitching() {
                const variantPicker = this.modalContent.querySelector('variant-selects');
                if (!variantPicker) return;

                // variantPicker.setAttribute('data-update-url', 'false');
            }

            removeDOMElements() {
                const pickupAvailability = this.productElement.querySelector('pickup-availability');
                if (pickupAvailability) pickupAvailability.remove();

                const productModal = this.productElement.querySelector('product-modal');
                if (productModal) productModal.remove();

                const modalDialog = this.productElement.querySelectorAll('modal-dialog');
                if (modalDialog) modalDialog.forEach((modal) => modal.remove());
            }

            preventDuplicatedIDs() {
                const sectionId = this.productElement.dataset.section;
console.log(sectionId);
                this.productElement.innerHTML = this.productElement.innerHTML;
                this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
                    element.dataset.originalSection = sectionId;
                });
            }

            removeGalleryListSemantic() {
                const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
                if (!galleryList) return;

                galleryList.setAttribute('role', 'presentation');
                galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
            }

            updateImageSizes() {
                const product = this.modalContent.querySelector('.product');
                const desktopColumns = product.classList.contains('product--columns');
                if (!desktopColumns) return;

                const mediaImages = product.querySelectorAll('.product__media img');
                if (!mediaImages.length) return;

                let mediaImageSizes =
                    '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

                if (product.classList.contains('product--medium')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '605px');
                } else if (product.classList.contains('product--small')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '495px');
                }

                mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
            }
        }
    );
}